import React from 'react';

function Footer() {
  const footerStyle = {
    background: 'linear-gradient(135deg, #013369 0%, #002244 100%)',
    borderTop: '3px solid #D50A0A'
  };

  return (
    <footer className="text-white mt-12 py-6 shadow-xl" style={footerStyle}>
      <div className="container mx-auto px-4 text-center">
        <p className="text-gray-700 text-sm">© 2025 Touchdown League</p>
      </div>
    </footer>
  );
}

export default Footer;
